import React, { useEffect, useRef, useState } from 'react';
import * as qs from "query-string";
import { openAppZalo, openZMP, openH5Binding, openUniversalLink, openZPIByDeepLink } from '../../CommonFunction';
import { createSession, trackingEventCallAPI } from "../../../api/trackingSDK";
import { EventTrackingList } from "../../../api/const";

const MobileHome = ({ bindingInfo }) => {
    const { REACT_APP_APPID_CAN_REDIRECT_TO_H5, REACT_APP_APPID_CAN_REDIRECT_TO_ZMP } = window.runtime_configs;
    const [redirecturl, setRedirecturl] = useState("")
    const [showH5, setShowH5] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    const session = useRef(null);
    const startTime = useRef(Date.now());

    const getSessionTracking = () => {
        if (!session.current) {
            createSession(res => {
                if (res) {
                    session.current = res;
                }
            })
        }
        return session.current
    }

    const sendEventTracking = (eventName) => {
        const session = getSessionTracking()
        const eventId = EventTrackingList.normalLandingPage.eventId[eventName];
        const metaData = {
            agent: navigator.userAgent,
            requestID: bindingInfo?.binding_token
        }
        trackingEventCallAPI(eventId, session, metaData)
    }

    const handleEventTrackingClickOpenApp = (eventName) => {
        const session = getSessionTracking()
        const eventId = EventTrackingList.normalLandingPage.eventId[eventName];
        const metaData = {
            agent: navigator.userAgent,
            requestID: bindingInfo?.binding_token,
            totalTime: (Date.now() - startTime.current) / 1000
        }
        trackingEventCallAPI(eventId, session, metaData)
    }

    const redirectToZMP = () => {
        console.log('open ZMP')
        handleEventTrackingClickOpenApp("openZMP")
        openZMP(bindingInfo);
    }

    const checkWhitelist =() => {
        return false
    }

    useEffect(() => {
        if (!session.current) {
            createSession(res => {
                if (res) {
                    session.current = res;
                }
            })
        }
        sendEventTracking('loadedMiddlePage1Success')
        if (checkWhitelist()) {
            setTimeout(() => {
                sendEventTracking('autoInvoke')
                openZPIByDeepLink(bindingInfo)
            }, 200)
            setTimeout(() => {
                sendEventTracking('loadedMiddlePage2Success')
                setShowLoading(false);
                setShowH5(true);
            }, 3000)
        }


        let params = qs.parse(window.location.href.split('?')[1]);
        if (Object.entries(params).length !== 0 && params.constructor !== Object) {
            setRedirecturl(params.redirect_url);
        } 

        document.body.className = 'mobilehome';

        const lstRedirectToH5 = REACT_APP_APPID_CAN_REDIRECT_TO_H5 ?? [];
        const isH5MobileApp = lstRedirectToH5.includes(bindingInfo.app_id)

        if (isH5MobileApp) {
            setShowH5(true);
        }

        return () => {
            document.body.className = '';
        }
        
        // eslint-disable-next-line no-use-before-define
    }, []);

    const openH5 = () => {
        openH5Binding(bindingInfo);
        handleEventTrackingClickOpenApp("clickOpenH5New")
    }

    const openAppZaloPay = () => {
        handleEventTrackingClickOpenApp("clientOpenZalopay")
        openUniversalLink(bindingInfo, redirecturl);
    }

    const openZPI = () => {
        handleEventTrackingClickOpenApp("clickOpenZalo")
        const listRedirectToZMP = REACT_APP_APPID_CAN_REDIRECT_TO_ZMP ?? [];
        if (listRedirectToZMP.includes(bindingInfo.app_id)) {
            redirectToZMP()
            return
        }
        openAppZalo(bindingInfo);
    }

    const autoLoadingApp = () => {
        return (
            <div id="loading-home">
                <div className="main-loading-section">
                    <div className="loading-invoke">
                        <div className="image-circle">
                            <img src={bindingInfo?.app_icon_url} alt="merchant" className="mc-logo"/>
                        </div>
                        <div className="arrow">
                            <span/>
                            <span/>
                            <span/>
                        </div>
                        <div className="zlp-logo-section">
                            <img src="/img/zlp-logo-new.svg" alt="zalopay" className="zlp-logo"/>
                        </div>
                    </div>
                    <h2 className="loading-msg">Bạn đang được chuyển đến Zalopay để liên kết và thanh toán</h2>
                </div>
            </div>
            
        )
    }

    const mobileHomeContent = () => {
        return (
                    <div id="body-h5-home">
                        <div className="open-app-section">
                            <div className="illus-art">
                                
                            </div>
                            <div className="logo-section">
                                <div className="merchant-logo">
                                    <img src={bindingInfo?.app_icon_url} alt="merchant" className="mc-logo" style={{width: "40px", height: "40px"}}/>
                                </div>
                                <div className="zlp-logo">
                                    <img src="/img/zlp-logo-new.svg" alt="zalopay" className="zlp-logo" style={{width: "40px", height: "40px"}} />
                                </div>
                            </div>
                            <label className="sub-title"><b>Liên kết với Zalopay để thanh toán đơn hàng</b></label>
                            <div className="btn-wrap-home"><button onClick={openAppZaloPay} className="btn btn-continue-zl-app" ><img className="img-zalo" src="/img/zlp-logo-new.svg" alt="Zalopay"/>Mở Zalopay để liên kết</button></div>
                            <div className="green-light" style={{width: "100%", padding: "0 16px"}}>
                                <button onClick={openZPI} className="btn btn-continue-zp-app">
                                    <img className="img-zalopay" src="/img/logo-zalo.svg" alt="Zalo" />Mở Zalo để liên kết
                                </button>
                            </div>
                        </div>
                        <div className="separate-wrap">
                            <hr className="separate"></hr>
                            <label>Hoặc</label>
                        </div>
                        <div className="install-app-section">
                            {showH5 &&
                                <div className="btn-wrap-home green-light">
                                    <button onClick={openH5} className="btn btn-continue-h5">
                                        <img className="img-zalopay" src="/img/phone-icon.svg" alt="H5" />Liên kết bằng số điện thoại
                                    </button>
                                </div>
                            }
                            
                        </div>
                        <div className="security-section">
                            <img src="/img/pci-dss.svg" alt="pci-dss" className="pci-dss"/>
                            <img src="/img/sec-logo.svg" alt="security" className="sec"/>
                            <p className="description">
                                Mọi thông tin giao dịch được bảo mật theo tiêu chuẩn quốc tế cao nhất.
                            </p>
                        </div>
                    </div>
        )
    }

    return (
        showLoading && checkWhitelist() ? autoLoadingApp() : mobileHomeContent()
    );
};

export default MobileHome;
